import { useNavigate } from "react-router-dom";
import Card from "../Card";
import ALEDRA from "../../../assets/imgs/aledra.png";
import COMERDESA from "../../../assets/imgs/comerdesa.png";

const LogosDashboard = () => {
    const navigate = useNavigate();

    const images = [
        { id: 1, src: ALEDRA, alt: "RS", route: "/inmobiliarias/" },
        { id: 2, src: COMERDESA, alt: "RS", route: "/inmobiliarias/" },
    ];

    return (
        <Card>
            <div className="w-full flex flex-row justify-around">
                {images.map((image) => (
                    <img
                        onClick={() => navigate(`${image.route}${image.id}`)}
                        src={image.src} alt={image.alt} key={image.id}
                        className="h-32 cursor-pointer hover:animate-pulse transition-transform duration-300 hover:scale-105 hover:drop-shadow-lg rounded-lg"
                    />
                ))}
            </div>
        </Card>
    );
};

export default LogosDashboard;
